import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import { organizationsApi } from '../api/organizations';
import '../pages/DashboardPages.css';
import defaultOrgPhoto from '../assets/Assemblie_DefaultChurchIcon.png';
import { useNavigate } from 'react-router-dom';

function DashboardAdminOrganizationManagement() {
	const [organizations, setOrganizations] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState('');
	const [searchTerm, setSearchTerm] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		fetchOrganizations();
	}, []);

	const fetchOrganizations = async () => {
		try {
			const response = await organizationsApi.getAll(searchTerm);
			setOrganizations(response.organizations);
		} catch (error) {
			setError('Failed to fetch organizations');
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<DashboardLayout>
			<div className='dashboard-page'>
				<h1>Organization Management</h1>
				<div className='content-section'>
					<div className='admin-controls'>
						<input
							type='text'
							placeholder='Search organizations...'
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							className='search-input'
						/>
						<button
							className='create-btn'
							onClick={() =>
								(window.location.href =
									'/dashboard/admin/organization/create')
							}>
							Create New Organization
						</button>
					</div>

					{error && <div className='error-message'>{error}</div>}

					{isLoading ? (
						<p>Loading organizations...</p>
					) : (
						<div className='table-responsive'>
							<table className='users-table'>
								<thead>
									<tr>
										<th>Photo</th>
										<th>Organization Name</th>
										<th>Organization PIN</th>
									</tr>
								</thead>
								<tbody>
									{organizations.map((org) => (
										<tr
											key={org.id}
											onClick={() =>
												navigate(
													`/dashboard/admin/organization/${org.id}`,
													{
														state: {
															organization: org,
														},
													}
												)
											}
											className='clickable-row'>
											<td>
												<img
													src={
														org.orgPicture ||
														defaultOrgPhoto
													}
													alt={org.name}
													className='user-avatar'
												/>
											</td>
											<td>{org.name}</td>
											<td>{org.pinNum}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</div>
			</div>
		</DashboardLayout>
	);
}

export default DashboardAdminOrganizationManagement;
